export const VAT_CORRECTIONS_CONSOLIDATED_VIEW_TABLE = 'vat_corrections_consolidated_view';

/** Max rows when loading VAT corrections for a single order (e.g. Order detail). */
export const ORDER_DETAIL_VAT_CORRECTIONS_PAGE_SIZE = 100;

export const EM_VAT_CORRECTIONS_IMPORT_VIEW_TABLE = 'em_vat_report_vat_corrections_import';
export const EM_VAT_CORRECTIONS_UNION_VIEW_TABLE = 'em_vat_report_vat_corrections_union';
export const EM_VAT_CORRECTIONS_NON_UNION_VIEW_TABLE = 'em_vat_report_vat_corrections_non_union';
export const EM_VAT_CORRECTIONS_NON_EU_VIEW_TABLE = 'em_vat_report_vat_corrections_non_eu_import';

export enum EEmVatCorrectionsApprovalStatus {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
}
